import { inferRouteObject } from 'react-router-typed-object';

import { OidcIssuerName } from '@/services/ws-companies/src/main/resources/rest-api';
import { Navigate } from '@/js/libs/router';

import { POST_ENDPOINTS } from 'src/modules/PostCampaign/index.ts';
import Authentication from 'src/scenes/Authentication/index.ts';

const index = true;

// Opens the SSO page on the Post and Coop hosts: their proxy signs the user in with the issuer and passes the issuer's
// tokens in the response headers, which the SSO page exchanges for a console token. Every other host opens the login
// form.
const getLoginPagePath = () => {
  if (POST_ENDPOINTS.includes(window.location.host)) {
    return `/authentication/sso/${OidcIssuerName.SWISS_POST}`;
  }
  if (import.meta.env.VITE_COOP_CONSOLE_ENDPOINT?.includes(window.location.host)) {
    return `/authentication/sso/${OidcIssuerName.COOP}`;
  }

  return '/authentication/login';
};

const loginPageRedirect = <Navigate replace to={getLoginPagePath()} />;

export const authenticationRouteObject = inferRouteObject({
  path: 'authentication',
  children: [
    { index, element: loginPageRedirect },
    {
      path: 'sso',
      children: [
        { index, element: loginPageRedirect },
        { path: ':issuerName', element: <Authentication.Components.SSO /> },
      ],
    },
    { path: 'autologin', Component: Authentication.Components.Autologin },
    {
      Component: Authentication.Components.Layout,
      children: [
        { path: 'login', Component: Authentication.Components.AppLogin },
        { path: 'change-password/:hash', Component: Authentication.Forms.ChangePassword },
        { path: 'activate/:hash', Component: Authentication.Forms.ActivateUser },
      ],
    },
  ],
});
